import { Rating } from 'primereact/rating';

export const NameColumn = (data, props) => {
    return (
        <>
            <span className="p-column-title">{data[props.field]}</span>
            {data[props.field]}
        </>
    );
};

export const TextColumn = (data, props) => {
    return (
        <>
            <span className="p-column-title">{data[props.field]}</span>
            <span className="truncate">{data[props.field]}</span>
        </>
    );
};

export const LinkColumn = (data, props) => {
    return (
        <>
            <a href={data[props.field]} className="p-column-title">{data[props.field]}</a>
            <a href={data[props.field]} className="truncate">{data[props.field]}</a>
        </>
    );
};


export const ImageColumn = (data, props) => {
    return (
        <div style={{"textAlign" : 'center'}}>
            {data.image ?
                <img src={data[props.field]} alt={data.image} className="shadow-2" width="80px" height="60px" /> :
                <img src={data[props.field]} alt={data.image} className="shadow-2"/>
            }
        </div>
    );
};

export const priceColumn = (data, props) => {

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    return (
        <>
            <span className="p-column-title">Price</span>
            {formatCurrency(data[props.field])}
        </>
    );
};

export const RatingColumn = (data, props) => {
    return (
        <>
            <span className="p-column-title">Reviews</span>
            <Rating value={data[props.field]} readOnly cancel={false} />
        </>
    );
};

export const StatusColumn = (data, props) => {

    const status = data[props.field] <= 0 ? 'outofstock' : data[props.field] <=10 ? 'lowstock' : 'instock' // class name must be in lowercase

    return (
        <>
            <span className="p-column-title">Status</span>
            <span className={`product-badge status-${status}`}>{status}</span>
        </>
    );
};

export const UrgentNormalStatusColumn = (data, props) => {

    const statusColor = data[props.field] === "Normal" ? '#5de35d' : '#ff7480';

    return (
        <>
            <span className="p-column-title">Status</span>
            <span className="truncate" style={{"background": statusColor, "borderRadius": "5px"}}>{data[props.field]}</span>
        </>
    );
};

export const CompleteStatusColumn = (data, props) => {

    const status = data[props.field] === true ? 'instock' : 'lowstock'; // class name must be in lowercase. instock=complete, lowstock=incomplete

    return (
        <>
            <span className="p-column-title">Status</span>
            <span className={`product-badge status-${status}`}>{data[props.field] === true ? 'Complete' : 'InComplete'}</span>
        </>
    );
};

export const ActiveInactivColumn = (data, props) => {

    const status = data[props.field] === true ? 'instock' : 'lowstock'; // class name must be in lowercase. instock=complete, lowstock=incomplete

    return (
        <>
            <span className="p-column-title">Status</span>
            <span className={`product-badge status-${status}`}>{data[props.field] === true ? 'Active' : 'Inactive'}</span>
        </>
    );
};